export const showModalDeliveryStatus = () => ({
  type: "SHOW_MODAL_DELIVERY_STATUS",
});

export const closeModalDeliveryStatus = () => ({
  type: "CLOSE_MODAL_DELIVERY_STATUS",
});
